import ChevronRight16 from '@carbon/icons-react/es/chevron--right/16';
import { TooltipPlacement } from 'antd/lib/tooltip';
import React, { ReactNode, FC } from 'react';
import styled, { css } from 'styled-components';
import { OutsideClickHandler } from 'components/atoms/outside-click-handler';
import { Popover as PopoverAtom } from 'components/atoms/popover';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { Action } from './components';

interface Props extends ClassNameOnlyProps {
  title: ReactNode;
  allowed: (target: HTMLElement) => boolean;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  hideChevron?: boolean;
  placement?: TooltipPlacement | undefined;
  disabled?: boolean;
}

const Popover = styled(PopoverAtom)`
  display: flex;
  flex-direction: column;

  .ant-popover-content {
    margin-right: calc(-1 * var(--spacing-03));
  }
`;

const Left = styled.div`
  flex: 1;
  display: inline-flex;
`;

const ControlledPopoverActionComponent: FC<Props> = ({
  title,
  allowed,
  children,
  visible,
  setVisible,
  className,
  hideChevron,
  placement,
  disabled,
}) => (
  <Popover
    className={className}
    trigger={[]}
    visible={visible}
    placement={placement || 'left'}
    destroyTooltipOnHide={{ keepParent: false }}
    content={children}
  >
    <OutsideClickHandler
      allowed={allowed}
      onOutsideClick={() => setVisible(false)}
    >
      <Action disabled={disabled} onClick={() => setVisible(!visible)}>
        <Left>{title}</Left>
        {!hideChevron && <ChevronRight16 />}
      </Action>
    </OutsideClickHandler>
  </Popover>
);

export const ControlledPopoverAction = styled(ControlledPopoverActionComponent)`
  ${Action} {
    ${({ visible }) =>
      visible &&
      css`
        background: var(--action-hover-background);
      `};
  }
`;
